const editableFields = ['account', 'points', 'bigPoints', 'nai5PermanentPoints', 'level', 'expireTime'];
const numericFields = new Set(['points', 'bigPoints', 'nai5PermanentPoints', 'level']);

export function createUserEditSnapshot(user) {
  const snapshot = { id: user.id, password: '' };
  for (const field of editableFields) snapshot[field] = user[field];
  return snapshot;
}

function normalize(field, value) {
  if (field === 'account') return value == null ? '' : String(value);
  if (value == null || String(value).trim() === '') return null;
  if (numericFields.has(field)) {
    const number = Number(value);
    if (!Number.isInteger(number) || number < -2147483648 || number > 2147483647
        || (field === 'level' && (number < -128 || number > 127))) {
      throw new Error('点数和级别必须是有效整数');
    }
    return number;
  }
  const timestamp = typeof value === 'number' || /^-?\d+$/.test(String(value))
    ? Number(value) : new Date(value).getTime();
  if (!Number.isFinite(timestamp)) throw new Error('过期时间格式无效');
  return timestamp;
}

// Omitted fields remain unchanged in the database, including balances spent
// after the edit dialog was opened and server-managed daily NAI5 allowances.
export function buildUserEditPatch(original, edited, resetPassword) {
  const patch = { id: original.id };
  for (const field of editableFields) {
    const before = normalize(field, original[field]);
    const after = normalize(field, edited[field]);
    if (before === after) continue;
    if (after === null) throw new Error('修改的点数、级别和过期时间不能为空');
    patch[field] = after;
  }
  if (resetPassword && typeof edited.password === 'string' && edited.password.trim()) {
    patch.password = edited.password;
  }
  return patch;
}
